import React, { useContext } from 'react';
import { TextareaProps } from 'atomic/form/textarea/textarea.interface';
import Icon from 'atomic/icon';
import classNames from 'classnames';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './textarea.scss';

let id = 0;

const Textarea: React.FC<TextareaProps> = React.forwardRef(({
    value,
    name,
    disabled,
    label,
    error,
    onChange,
    onBlur,
    icon,
    onKeyPress,
    rows = 4
}: TextareaProps, ref: React.Ref<HTMLTextAreaElement>) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const idx = id++;

    return (
        <div className="form-textarea">
            <textarea
                name={name}
                value={value}
                ref={ref}
                onChange={onChange}
                onKeyPress={onKeyPress}
                onBlur={onBlur}
                rows={rows}
                className={classNames(
                    {
                        ['textarea']: true,
                        ['textarea--disabled']: Boolean(disabled),
                        ['textarea--error']: Boolean(error),
                        ['textarea--icon']: Boolean(icon),
                        ['textarea--mobile']: api.getDevice() === 'mobile'
                    }
                )}
                id={idx.toString()}
                disabled={disabled}
                placeholder="&nbsp;"
                aria-label={name}
            />
            <label
                className={classNames(
                    {
                        ['textarea-label']: true,
                        ['textarea-label--error']: Boolean(error)
                    }
                )}
                data-label={label}
            />
            {error && (
                <span className="textarea-error-message">
                    {error.message}
                </span>
            )}
            {icon && (
                <Icon
                    className={classNames(
                        {
                            ['textarea-icon']: true
                        }
                    )}
                    name={icon.name}
                    title={icon.title}
                    size={18}
                />
            )}
        </div>
    );
});

Textarea.displayName = 'Textarea';

export default Textarea;
